// extracted by mini-css-extract-plugin
export default {"titleIconContainer":"Title_titleIconContainer__OsW3i","title":"Title_title__tlUPg","titleContainer":"Title_titleContainer__ImbIu"};